import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { SEQUENCES_LIST_KEY } from '@teetsh/app/src/queries/sequences/useSequencesFolders';
import { SEQUENCE_KEY } from '@teetsh/app/src/queries/sequences/useSequence';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

export function useDeleteStandaloneFicheDePrep() {
  const queryClient = useQueryClient();
  const { notifyError } = useNotification();
  const { t } = useTranslation(['sequence']);

  return useMutation({
    mutationFn: ({ ficheDePrepId }: { ficheDePrepId: string }) =>
      request(`/fiches-de-prep/${ficheDePrepId}`, {
        method: 'DELETE',
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_LIST_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [SEQUENCE_KEY],
      });
    },
    onError: () => {
      notifyError({
        title: t('sequence:messages.seance.deleteError'),
      });
    },
  });
}
